import React from 'react';
import { useTranslation } from 'react-i18next';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styles from './style.module.css';

export default function DropZoneContent({
  selectedFile,
  isDragActive,
  error,
  maxSize,
  placeholder,
}) {
  const { t } = useTranslation();

  const getIconClasses = () => {
    let classes = [styles.uploadIcon];
    
    if (error) {
      classes.push(styles.error);
    } else if (isDragActive) {
      classes.push(styles.dragActive);
    } else {
      classes.push(styles.default);
    }
    
    if (selectedFile) {
      classes.push(styles.fileSelected);
    }
    
    return classes.join(' ');
  };

  const getTitleClasses = () => {
    let classes = [styles.uploadTitle];
    
    if (error) {
      classes.push(styles.error);
    } else {
      classes.push(styles.default);
    }
    
    return classes.join(' ');
  };

  return (
    <>
      <CloudUploadIcon className={getIconClasses()} />
      
      <div className={getTitleClasses()}>
        {isDragActive
          ? t('modals.dropFileHere')
          : selectedFile
          ? t('modals.replaceFile')
          : placeholder || t('modals.uploadDocument')}
      </div>
      
      <div className={styles.uploadSubtext}>
        {t('modals.dragDropOrClick')}
      </div>
      
      {maxSize && (
        <div className={styles.uploadMaxSize}>
          {t('modals.maxFileSize', {
            maxSize: Math.round(maxSize / 1000000),
          })}{' '}
          MB
        </div>
      )}
    </>
  );
}